import React from 'react';
import { cn } from '../../utils/cn';
import { usePreferences } from '../../preferences/PreferencesContext';
import type { Locale } from '../../preferences/preferencesStorage';

const OPTIONS: Array<{ value: Locale; label: string }> = [
  { value: 'id', label: 'ID' },
  { value: 'en', label: 'EN' },
];

export function LocaleSwitcher({ className }: { className?: string }) {
  const { locale, setLocale } = usePreferences();

  return (
    <div
      className={cn(
        'inline-flex items-center rounded-lg border border-slate-200 bg-white p-0.5 dark:border-slate-700 dark:bg-slate-900',
        className,
      )}
      role="group"
      aria-label="Language"
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => setLocale(opt.value)}
          className={cn(
            'rounded-md px-2 py-1 text-[11px] font-semibold transition',
            locale === opt.value
              ? 'bg-red-600 text-white'
              : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
